<template>
  <!-- 添加文章 -->
  <div class="vue">
    <div class="header flex flexAi-c flexJc-sb">
      <div class="text">{{ title }}</div>
      <a-button
        @click="goBack"
        size="small"
        type="primary"
        icon="rollback"
      >
        返回
      </a-button>
    </div>
    <div class="content ">
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item
          ref="name"
          label="文章标题"
          prop="name"
        >
          <a-input v-model="form.name" />
        </a-form-model-item>
        <a-form-model-item
          ref="cascader"
          label="所属分类"
          prop="cascader"
        >
          <a-cascader
            placeholder="选择所属分类，如只选一级栏目就不用点击二级栏目"
            v-model="form.cascader"
            :field-names="{ label: 'name', value: 'id', children: 'list' }"
            :options="optionsList"
            change-on-select
          />
        </a-form-model-item>

        <a-form-model-item label="文章图片">
          <a-upload
            name="file"
            accept="image/png,image/jpg,image/jpeg"
            list-type="picture-card"
            class="avatar-uploader"
            :show-upload-list="false"
            :action="uploadImage"
            @change="handleChange"
          >
            <img
              class="image"
              v-if="form.imageUrl"
              :src="form.imageUrl"
              alt="avatar"
            />
            <div v-else>
              <a-icon :type="loading ? 'loading' : 'plus'" />
              <div class="ant-upload-text">
                添加图片
              </div>
            </div>
          </a-upload>
        </a-form-model-item>

        <a-form-model-item label="上传文档">
          <a-switch v-model="form.delivery" />
        </a-form-model-item>
        <a-form-model-item
          label="文档上传"
          v-if="form.delivery"
        >
          <a-upload
            accept=".doc,.docx,.pdf,.pptx"
            name="file"
            :default-file-list="fileList"
            :action="uploadImage"
            :remove="handleDownloadFileRemove"
            :beforeUpload="beforeUploadFile"
            @change="uploadFileChange"
          >
            <a-button>
              <a-icon type="upload" /> 点击上传
            </a-button>
          </a-upload>
        </a-form-model-item>
        <a-form-model-item label="首页展示">
          <a-switch v-model="form.show" />
        </a-form-model-item>
        <a-form-model-item
          label="所属排序"
          v-if="form.show"
        >
          <a-input-number
            class="width100"
            v-model="form.sort"
            :min="1"
            :max="100"
          />
        </a-form-model-item>
        <!-- <a-form-model-item label="文章内容">
            <Ueditor v-model="UEditor"></Ueditor>
          </a-form-model-item> -->
        <a-form-model-item label="文章内容">
          <vue-ueditor-wrap
            class="ueditor"
            v-model="form.content"
            :config="myConfig"
          ></vue-ueditor-wrap>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
          <a-button
            type="primary"
            :loading="butLoading"
            @click="onSubmit"
          >
            确认
          </a-button>
          <a-button
            style="margin-left: 10px;"
            @click="goBack"
          >
            取消
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
  </div>
</template>

<script>
import VueUeditorWrap from 'vue-ueditor-wrap' // ES6 Module
let that
export default {
  name: '',
  props: [''],
  data() {
    return {
      articleData: '', // 数据接受；编辑
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      uploadImage: '', // 上传图片接口
      title: '添加文章',
      other: '',
      optionsList: [], // 所属分类
      cascader: [], // 当前选中的分类
      form: {
        name: '',
        sort: '', // 所属排序
        cascader: [],
        uploadFile: '',
        imageUrl: '',
        content: '', // 文本内容
        url: '',
        select: '',
        delivery: false, // 开关-文件上传
        show: false // 开关-是否展示首页（荣誉资质）
      },
      fileList: [], // 文件列表
      loading: false, // 上传图片用
      rules: {
        name: [
          {
            required: true,
            message: '标题不能为空!',
            trigger: 'blur'
          }
        ],
        cascader: [
          {
            required: true,
            message: '所属分类不能为空!',
            trigger: 'blur'
          }
        ]
      },

      provinceData: ['Zhejiang', 'Jiangsu'],
      cityData: {
        Zhejiang: ['Hangzhou', 'Ningbo', 'Wenzhou'],
        Jiangsu: ['Nanjing', 'Suzhou', 'Zhenjiang']
      },
      cities: [],
      secondCity: '',
      // 富文本
      canCrop: false,
      /* 上传图片的接口，返回结构为{url:''} */
      actionUrl: '', // 上传接口
      // uploadUrl: 'http://app.hcwxehs.com/hc/upload/upload.do'
      butLoading: false, // 按钮提交
      // vue-ueditor-wrap
      UEditor: '',
      myConfig: {
        UEDITOR_HOME_URL: '/UEditor/',
        serverUrl: ''
      }
    }
  },

  components: {
    VueUeditorWrap
  },

  computed: {},

  beforeMount() { },
  mounted() {
    that = this
    this.uploadImage = this.baseURL + '/upload/upload'
    this.myConfig.serverUrl = this.baseURL + '/upload/ueditorUpload.do'
    if (this.$route.query.info !== undefined) {
      this.title = '编辑文章'
      this.articleData = JSON.parse(this.$Base64.decode(this.$route.query.info))
      this.articleEdut()
    }
    console.log(this.articleData)

    this.NavigationFindAll()
  },

  methods: {
    // 返回
    goBack() {
      this.$router.go(-1)
    },
    // 编辑
    articleEdut() {
      this.form.name = this.articleData.name
      this.form.content = this.articleData.text
      this.form.imageUrl = this.articleData.img
      this.form.uploadFile = this.articleData.url
      this.form.cascader[0] = this.articleData.parentType
      if (this.articleData.type !== null) {
        this.form.cascader[1] = this.articleData.type
      }
      if (this.articleData.uploadFile !== null) {
        this.form.delivery = true
      }
      console.log(this.articleData.sort)
      this.form.show = this.ISString(this.articleData.show)
      this.form.sort = this.articleData.sort

      this.fileList[0] = {
        uid: '-1',
        name: 'xxx',
        status: 'done',
        url: this.articleData.uploadFile
      }
    },
    // 确定创建按钮
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.form.show && this.form.sort === '') {
            this.$Me('首页排序不能为空！')
            return
          }
          console.log(that.form.show)
          let newShow = ''
          let navigationId = '' // 子级 id
          let firstId = '' // 父级ID
          newShow = that.ISBoolean(that.form.show)
          console.log(newShow)
          firstId = this.form.cascader[0]
          if (this.form.cascader.length === 2) {
            navigationId = this.form.cascader[1]
          }
          console.log(navigationId)
          this.butLoading = true
          this.$postAxios('/article/addArticle', {
            id: this.articleData.id,
            show: newShow,
            sort: this.form.sort,
            name: this.form.name,
            text: this.form.content,
            img: this.form.imageUrl,
            uploadFile: this.form.uploadFile,
            parentType: firstId,
            type: navigationId
          })
            .then(res => {
              this.butLoading = false
              if (res.status === '0') {
                this.$message.success(res.msg)
                this.form = {
                  name: '',
                  sort: '',
                  cascader: [],
                  uploadFile: '',
                  imageUrl: '',
                  content: '',
                  url: '',
                  select: '',
                  delivery: false, // 开关
                  show: false // 开关-是否展示首页（荣誉资质）
                }
                if (this.articleData !== '') {
                  this.$router.go(-1)
                }
              }
            })
            .catch(() => {
              this.$Me('请求超时')
              this.butLoading = false
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 标题图片--图片上传回调
    handleChange(info) {
      console.log(info)

      if (info.file.status === 'uploading') {
        this.loading = true
        return
      }
      if (info.file.status === 'done') {
        this.form.imageUrl = info.file.response.data
        this.loading = false
      }
    },
    /**
     * 文件上传-自定义上传行为 //标题图
     * */
    uploadFileChange(params) {
      // 上传成功后操作
      if (params.file.status === 'done') {
        this.form.uploadFile = params.file.response.data
      }
    },
    // 文件上传前得回调
    beforeUploadFile(file) {
      console.log(file)
      return new Promise((resolve, reject) => {
        if (this.form.uploadFile !== '') {
          this.$message.error('最多上传一个')
          reject(file)
        } else {
          resolve(file)
        }
      })
    },
    /**
     * 标题图片上传-自定义上传行为 //标题图
     * */
    uploadSectionFile(params) {
      const file = params.file
      const fileType = file.type
      const isImage = fileType.indexOf('image') !== -1
      const isLt2M = file.size / 1024 / 1024 < 1
      console.log(file)
      // 这里常规检验，看项目需求而定
      if (!isImage) {
        this.$message.error('只能上传图片格式png、jpg、gif!')
        return
      }
      if (!isLt2M) {
        this.$message.error('只能上传小于1M的图片')
        return
      }
      // 根据后台需求数据格式
      const form = new FormData()
      // 文件对象
      form.append('upload_file', file)
      form.append('path', 'articleImg') // 添加form表单中其他数据
      console.log(form)
      this.$postAxios('/upload/upload', { file: form }).then(res => {
        if (res.status === 0) {
          this.form.imageUrl = this.baseImg + '/' + res.data
        }
      })
      // apiUpload(form).then(res => {
      //   if (res.status === 0) {
      //     this.form.imageUrl = this.baseImg + '/' + res.data
      //   }
      // })
    },

    /* 文件删除 */
    handleDownloadFileRemove(file) {
      console.log(file)
      this.form.uploadFile = ''
      this.fileList = []
    },

    /* 接口 */
    // 获取导航栏列表
    NavigationFindAll() {
      this.$postAxios('/navigation/findAll').then(res => {
        if (res.status === '0') {
          this.optionsList = res.data
        }
      })
    }
  },

  watch: {}
}
</script>
<style lang="scss" scoped>
$colorMajor: #005ca1;
/deep/ iframe {
  width: 100%;
 /deep/ body{
max-width: 100%;
    max-height: 100%;
    height: auto;
  }
  /deep/ .image {
    max-width: 100%;
    max-height: 100%;
    height: auto;
  }
}
.vue {
  padding: 10px;
  background-color: #fff;
  border-left: 2px solid $colorMajor;
  // height: calc(100% - 90px);
  overflow: auto;

  height: 100%;
  .header {
    height: 40px;
    border-bottom: 1px solid #f3f3f3;
    .text {
      text-align: left;
      // font-size: 0.875em;
      color: $colorMajor;
      padding: 10px 5px;
    }
    .el-button {
      margin: 10px;
    }
  }
  .content {
    height: calc(100% - 40px);
    padding: 15px 0;
    position: relative;
    overflow: hidden;
    .ant-form {
      position: absolute;
      height: 100%;
      width: 100%;
      left: 0;
      overflow-x: hidden;
      overflow-y: scroll;
    }
    .ant-form::-webkit-scrollbar {
      display: none;
    }
    .ant-row {
      /deep/ .ant-form-item-control-wrapper {
        text-align: left;
        .avatar-uploader {
          /deep/ img {
            width: 100px;
            height: 100px;
          }
        }
      }
    }
  }
}
</style>
<style>

</style>
